import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { guaranteeList } from "../../data/content";
import { TransformCta } from "../ui/TransformCta";
export function GuaranteeSection() {
  return <section className="bg-paper px-5 py-16 sm:py-24" data-id="element-122" data-mp="1kau5mfyt6rzd">
      <div className="mx-auto max-w-3xl" data-id="element-123" data-mp="1k9j4yp0nu0ch">
        <div className="text-center" data-id="element-124" data-mp="1fbpxztrj92b5">
          <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-white" data-id="element-125" data-mp="1faom5n2p0bsd">
            <ShieldCheckIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-126" data-mp="15e3eetzagmku" />
            <span className="mt-1 font-display text-2xl font-extrabold leading-none" data-id="element-127" data-mp="11d01ogcjf6nu">7-Day</span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-128" data-mp="wdwv2rgwssdr">Guarantee</span>
          </div>
          <p className="mt-6 text-sm font-bold uppercase tracking-[0.18em] text-cyan" data-id="element-129" data-mp="2vrkek6um9xwo">Your 7-Day Guarantee</p>
          <h2 className="mt-3 font-display text-[2rem] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-130" data-mp="2qrocid5hcgjr">
            Explore the Endo Blueprint™ Before Deciding Whether It's Right for You
          </h2>
        </div>
        <div className="mt-8 space-y-4 text-lg leading-relaxed text-ink/85" data-id="element-131" data-mp="1l4ptws42me1f">
          <p data-id="element-132" data-mp="174x9tfn1uw2f">
            I want you to have the opportunity to review the material and decide whether it fits your educational and
            professional needs. That's why your purchase comes with a 7-day guarantee, subject to the published refund
            terms.
          </p>
          <p className="font-semibold text-ink" data-id="element-133" data-mp="23u66idt15wy7">During that period, you can:</p>
        </div>
        <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-134" data-mp="1q39hewybbxvw">
          {guaranteeList.map(g => <li key={g} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-135" data-mp="1v1ukd44y8vo1">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-136" data-mp="1uzrkzthwpq6n" />
              {g}
            </li>)}
        </ul>
        <p className="mt-6 text-lg leading-relaxed text-ink/85" data-id="element-137" data-mp="2njgltqov6fvs">
          If the product doesn't meet your expectations, follow the refund instructions provided with your purchase within
          the guarantee period. <strong className="text-ink" data-id="element-138" data-mp="2sglyycw72h2k">My goal is to make your decision straightforward and transparent.</strong>
        </p>
        <TransformCta label="Get the Endo Blueprint™ — 7-Day Guarantee" data-id="element-139" data-mp="2niar27pgmgmz" />
      </div>
    </section>;
}